<template>
  <div>
    <h1>{{ pageTitle }}</h1>
    <h3>Videos</h3>
    <youtube video-id="2Edq3-5h2UA" player-width="640" player-height="360"></youtube>
    <hr>
    <h3>Photos</h3>
    <p>Click the links under each photo to download the corresponding size. Contact jeremy@ecosupplycenter.com if you need a specific image that you do not see in the library.</p>
    <p><a class="button" href="https://www.flickr.com/photos/165529865@N03/" target="_blank">View Our Flickr Library</a></p>
    <div class="gallery columns is-multiline is-vcentered is-marginless">
        <flickr-card v-for="image in images" :key="image" :image="image" />
    </div>

  </div>
</template>

<script>
// import Color from '@/components/Color.vue'
import FlickrCard from '@/components/FlickrCard.vue'
import axios from 'axios'
export default {
  components: {
    FlickrCard
  },
  data () {
    return {
      pageTitle: 'Media Library',
      images: null,
      isImageModalActive: false
    }
  },
  computed: {
    tag: function () {
      let t = this.pageTitle.toLowerCase().replace(/\s+/g, '')
      return t
    }
  },
  mounted () {
    axios
      .get('https://c0345.paas3.tx.modxcloud.com/fapi.php?method=flickr.photos.search&format=json&nojsoncallback=1&user_id=165529865@N03&per_page=500&media=photos&extras=url_o,original_format')
      .then(response => (this.images = response.data.photos.photo))
  }
}
</script>

<style lang="scss">
iframe {
  min-height: 360px;
}
</style>
